import React from "react";
import { Link } from "react-router-dom";
import * as Ph from "@phosphor-icons/react";
import { Check } from "lucide-react";
import { Reveal, SectionHeading, Starburst } from "../common";
import { SERVICES, SCHEDULE_FEATURES } from "../../data/site";

const Services = () => (
  <section
    id="services"
    className="py-24 md:py-32 bg-background scroll-mt-20"
    data-testid="services-section"
  >
    <div className="max-w-[88rem] mx-auto px-5 md:px-10">
      <Reveal>
        <SectionHeading
          overline="Full-Service Cleaning"
          title="Everything you need. One dependable team."
        />
      </Reveal>

      <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {SERVICES.map((s, i) => {
          const Icon = Ph[s.icon] || Ph.Sparkle;
          const featured = s.tag === "Specialty";
          return (
            <Reveal key={s.name} delay={(i % 4) * 0.06}>
              {(() => {
                const inner = (
                  <>
                    <div
                      className={`grid place-items-center h-12 w-12 rounded-xl mb-6 transition-colors ${
                        featured
                          ? "bg-jet-teal text-white"
                          : "bg-jet-teal/10 text-jet-teal group-hover:bg-jet-teal group-hover:text-white"
                      }`}
                    >
                      <Icon size={26} weight="duotone" />
                    </div>
                    <div
                      className={`text-[10px] font-bold uppercase tracking-[0.18em] mb-1.5 ${
                        featured ? "text-jet-amber" : "text-jet-teal-deep"
                      }`}
                    >
                      {s.tag}
                    </div>
                    <h3
                      className={`font-display text-lg md:text-xl font-semibold leading-tight ${
                        featured ? "text-white" : "text-jet-ink"
                      }`}
                    >
                      {s.name}
                    </h3>
                  </>
                );
                const cls = `group block h-full rounded-2xl p-6 md:p-7 border transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-1 ${
                  featured
                    ? "bg-jet-ink border-jet-ink text-white hover:shadow-[0_20px_50px_-20px_rgba(0,180,216,0.5)]"
                    : "bg-card border-border hover:border-jet-teal/40 hover:shadow-lg"
                }`;
                return s.slug ? (
                  <Link to={`/${s.slug}`} className={cls} data-testid={`service-card-${i}`}>
                    {inner}
                  </Link>
                ) : (
                  <div className={cls} data-testid={`service-card-${i}`}>
                    {inner}
                  </div>
                );
              })()}
            </Reveal>
          );
        })}
      </div>

      {/* Scheduling */}
      <Reveal delay={0.1}>
        <div className="mt-8 rounded-3xl bg-gradient-to-br from-jet-teal to-jet-teal-deep p-8 md:p-14 text-white relative overflow-hidden">
          <Starburst className="absolute -right-8 -top-8 h-48 w-48 text-white/10" />
          <div className="relative">
            <div className="text-xs font-bold uppercase tracking-[0.22em] text-white/80 mb-3">
              Flexible Scheduling
            </div>
            <h3 className="font-display text-3xl md:text-5xl font-semibold max-w-2xl leading-[0.98]">
              Cleaning that works around your schedule.
            </h3>
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3">
              {SCHEDULE_FEATURES.map((f) => (
                <div key={f} className="flex items-center gap-2.5 font-medium text-white/90">
                  <span className="grid place-items-center h-5 w-5 rounded-full bg-white/20 shrink-0">
                    <Check className="h-3 w-3" strokeWidth={3} />
                  </span>
                  {f}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Services;
